module.exports = __webpack_public_path__ + "img/29_49.50878dda.png";